/**
 * LatLng Model for FlowRide Frontend
 * Represents geographic coordinates with latitude, longitude, and optional altitude.
 * Used for location data and coordinate calculations.
 */

export class LatLng {

    /** Latitude coordinate in decimal degrees */
    lat!: number;


    /** Longitude coordinate in decimal degrees */
    lng!: number;


    /** Optional altitude in meters above sea level */
    alt?: number | undefined;

    /**
     * Create a new LatLng instance
     * @param latitude - Latitude coordinate
     * @param longitude - Longitude coordinate
     * @param altitude - Optional altitude coordinate
     */
    constructor( latitude: number, longitude: number, altitude?: number ) {
        this.lat = latitude;
        this.lng = longitude;
        this.alt = altitude;
    }

}
